/* eslint-disable */
import { RINGS_TYPE } from '@ringcentral-integration/commons/modules/RingtoneConfiguration/const';
export default {
  [RINGS_TYPE.Phone_Ring1]: 'Beltoon 1',
  [RINGS_TYPE.Phone_Ring2]: 'Beltoon 2',
  [RINGS_TYPE.Acoustic_Dreams]: 'Akoestische dromen',
  [RINGS_TYPE.Air_Raid]: 'Luchtaanval',
  [RINGS_TYPE.Allusive]: 'Zinspelend',
  [RINGS_TYPE.Attention]: 'Let op',
  [RINGS_TYPE.Blub_Blub]: 'Blub blub',
  [RINGS_TYPE.Buzzy]: 'Zoemend',
  [RINGS_TYPE.Channel_Open]: 'Kanaal open',
  [RINGS_TYPE.Contemplation]: 'Reflectie',
  [RINGS_TYPE.Crystal_Ball]: 'Kristallen bol',
  [RINGS_TYPE.Disco]: 'Disco',
  [RINGS_TYPE.Door_Bell]: 'Deurbel',
  [RINGS_TYPE.Fairy]: 'Elfje',
  [RINGS_TYPE.Fast_Bells]: 'Snelle bellen',
  [RINGS_TYPE.High_Gong]: 'Hoge gong',
  [RINGS_TYPE.Immersion]: 'Onderdompeling',
  [RINGS_TYPE.Indeed]: 'Inderdaad',
  [RINGS_TYPE.Lazy_Day]: 'Luie dag',
  [RINGS_TYPE.Neural_Funk]: 'Neurale funk',
  [RINGS_TYPE.Nice]: 'Mooi',
  [RINGS_TYPE.Ring]: 'Ring',
  [RINGS_TYPE.Ringing_Bells]: 'Rinkelende bellen',
  [RINGS_TYPE.Simple]: 'Simpel',
  [RINGS_TYPE.Soothing]: 'Kalmerend',
  [RINGS_TYPE.Sunshine]: 'Zonneschijn',
  [RINGS_TYPE.Off]: 'Uit',
  add: 'Toevoegen',
  delete: 'Verwijderen',
  play: 'Afspelen',
  cancel: 'Annuleren',
  confirmToDelete: '{name} verwijderen?',
} as const;

// @key: @#@"[RINGS_TYPE.Phone_Ring1]"@#@ @source: @#@"Phone Ring 1"@#@
// @key: @#@"[RINGS_TYPE.Phone_Ring2]"@#@ @source: @#@"Phone Ring 2"@#@
// @key: @#@"[RINGS_TYPE.Acoustic_Dreams]"@#@ @source: @#@"Acoustic Dreams"@#@
// @key: @#@"[RINGS_TYPE.Air_Raid]"@#@ @source: @#@"Air Raid"@#@
// @key: @#@"[RINGS_TYPE.Allusive]"@#@ @source: @#@"Allusive"@#@
// @key: @#@"[RINGS_TYPE.Attention]"@#@ @source: @#@"Attention"@#@
// @key: @#@"[RINGS_TYPE.Blub_Blub]"@#@ @source: @#@"Blub Blub"@#@
// @key: @#@"[RINGS_TYPE.Buzzy]"@#@ @source: @#@"Buzzy"@#@
// @key: @#@"[RINGS_TYPE.Channel_Open]"@#@ @source: @#@"Channel Open"@#@
// @key: @#@"[RINGS_TYPE.Contemplation]"@#@ @source: @#@"Contemplation"@#@
// @key: @#@"[RINGS_TYPE.Crystal_Ball]"@#@ @source: @#@"Crystal Ball"@#@
// @key: @#@"[RINGS_TYPE.Disco]"@#@ @source: @#@"Disco"@#@
// @key: @#@"[RINGS_TYPE.Door_Bell]"@#@ @source: @#@"Door Bell"@#@
// @key: @#@"[RINGS_TYPE.Fairy]"@#@ @source: @#@"Fairy"@#@
// @key: @#@"[RINGS_TYPE.Fast_Bells]"@#@ @source: @#@"Fast Bells"@#@
// @key: @#@"[RINGS_TYPE.High_Gong]"@#@ @source: @#@"High Gong"@#@
// @key: @#@"[RINGS_TYPE.Immersion]"@#@ @source: @#@"Immersion"@#@
// @key: @#@"[RINGS_TYPE.Indeed]"@#@ @source: @#@"Indeed"@#@
// @key: @#@"[RINGS_TYPE.Lazy_Day]"@#@ @source: @#@"Lazy Day"@#@
// @key: @#@"[RINGS_TYPE.Neural_Funk]"@#@ @source: @#@"Neural Funk"@#@
// @key: @#@"[RINGS_TYPE.Nice]"@#@ @source: @#@"Nice"@#@
// @key: @#@"[RINGS_TYPE.Ring]"@#@ @source: @#@"Ring"@#@
// @key: @#@"[RINGS_TYPE.Ringing_Bells]"@#@ @source: @#@"Ringing Bells"@#@
// @key: @#@"[RINGS_TYPE.Simple]"@#@ @source: @#@"Simple"@#@
// @key: @#@"[RINGS_TYPE.Soothing]"@#@ @source: @#@"Soothing"@#@
// @key: @#@"[RINGS_TYPE.Sunshine]"@#@ @source: @#@"Sunshine"@#@
// @key: @#@"[RINGS_TYPE.Off]"@#@ @source: @#@"Off"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"delete"@#@ @source: @#@"Delete"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirmToDelete"@#@ @source: @#@"Delete {name}?"@#@
